import React from "react";

const PermitUploadIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="28" cy="28" r="28" fill="#349AE2" />
    <path
      d="M26.6666 33.334V22.4673L23.2 25.934L21.3333 24.0007L28 17.334L34.6666 24.0007L32.8 25.934L29.3333 22.4673V33.334H26.6666ZM20 38.6673C19.2666 38.6673 18.6389 38.4062 18.1166 37.884C17.5944 37.3618 17.3333 36.734 17.3333 36.0007V32.0007H20V36.0007H36V32.0007H38.6666V36.0007C38.6666 36.734 38.4055 37.3618 37.8833 37.884C37.3611 38.4062 36.7333 38.6673 36 38.6673H20Z"
      fill="white"
    />
  </svg>
);

export default PermitUploadIcon;
